// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

import Vue from "vue";
import App from "./App";
import router from "./router";
import "element-ui/lib/theme-chalk/index.css";
import element from "./element/index";
import "./styles/index.css"; // global css
import VueCookies from "vue-cookies";
import "babel-polyfill";
import VueWechatTitle from "vue-wechat-title";
Vue.config.productionTip = false;
Vue.use(element);
Vue.use(VueCookies);
Vue.use(VueWechatTitle);
/* eslint-disable no-new */
router.afterEach((to, from, next) => {
  window, scrollTo(0, 0);
});
new Vue({
  el: "#app",
  router,
  components: { App },
  template: "<App/>"
});
